import { render, staticRenderFns } from "./text-field-date.vue?vue&type=template&id=dfb60b72&scoped=true"
import script from "./text-field-date.vue?vue&type=script&lang=ts"
export * from "./text-field-date.vue?vue&type=script&lang=ts"
import style0 from "./text-field-date.vue?vue&type=style&index=0&id=dfb60b72&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb60b72",
  null
  
)

export default component.exports